import { useState } from "react";

const features = [
  { icon: "ri-map-pin-time-line", title: "清单常新", desc: "地址状态与更新时间会定期同步，方便你随手判断哪个能用。" },
  { icon: "ri-shuffle-line", title: "逻辑清晰", desc: "主站 + 备用编号清清楚楚，互换有顺序，追更不慌乱。" },
  { icon: "ri-user-heart-line", title: "实用优先", desc: "不堆噱头，把真正管用的多地址互换与可用检测讲明白。" },
];

const testimonials = [
  { name: "熬夜追更的桃桃", role: "换地址老手", quote: "之前一到晚上就卡，按这儿的顺序切备用，基本没断过，真的很省心。" },
  { name: "数码控小圆", role: "喜欢研究线路", quote: "可用检测那几个判断点很实在，一测一个准，不用再瞎试。" },
  { name: "信息整理控 阿凯", role: "收藏强迫症", quote: "把地址统一存进一个文件夹再编号，这个习惯直接治好我的收藏混乱。" },
];

export default function About() {
  const [sent, setSent] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    const fd = new FormData(e.currentTarget);
    const websiteAlt = String(fd.get("website_alt") || "").trim();
    const payload = new FormData();
    if (fd.get("name")) payload.append("name", String(fd.get("name")));
    if (fd.get("email")) payload.append("email", String(fd.get("email")));
    if (fd.get("message")) payload.append("message", String(fd.get("message")));
    const url = "https://readdy.ai/api/form/dafbps1tto0ceqqnh9og";
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(
          Object.fromEntries(Array.from(payload.entries()).map(([k, v]) => [k, String(v)]))
        ).toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = text ? JSON.parse(text) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        (parsed && (parsed.meta?.message || parsed.message)) || "";
      if (!res.ok || !parsed || parsed.code !== "OK" || serverMsg.includes("spam")) {
        setError(serverMsg && serverMsg !== "OK" ? serverMsg : "提交失败了，请稍后再试。");
        return;
      }
      setSent(true);
      setName("");
      setEmail("");
      setMsg("");
    } catch {
      setError("网络出了点问题，请稍后重试。");
    }
  };

  return (
    <div id="about" className="bg-background-100/70">
      <div className="mx-auto max-w-6xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
        {/* 关于 + 口碑 */}
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
              <i className="ri-community-line" /> 关于本站
            </p>
            <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
              只想把「吃瓜网址怎么用」讲清楚
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              做这个指南站的初衷很简单：很多朋友在切换吃瓜网址多个地址时全靠乱试，要么一个地址点到死，
              要么地址换着换着把自己绕晕。于是我把「备用几个、怎么互换、如何检测可用」整理成一套顺手就能用的方法，
              并用一张地址清单把状态、速度、更新时间都标出来。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们不追逐「哪个瓜更大」，只把稳定访问这件事做扎实——更新入口状态、优化互换顺序、
              沉淀可用检测经验，让你每次点开都对、都顺。
            </p>

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {features.map((f) => (
                <div key={f.title} className="rounded-2xl bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-lg text-accent-700">
                    <i className={f.icon} />
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-950 md:text-base">{f.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-3xl bg-foreground-900 p-7 text-background-50 md:p-8">
              <h3 className="flex items-center gap-2 text-lg font-bold text-background-50">
                <i className="ri-heart-3-line text-primary-400" /> 他们说
              </h3>
              <p className="mt-1 text-xs text-background-300">来自网友的使用感受</p>
              <div className="mt-5 space-y-4">
                {testimonials.map((t) => (
                  <figure key={t.name} className="rounded-2xl bg-foreground-800/60 p-4">
                    <blockquote className="text-sm leading-relaxed text-background-100">
                      “{t.quote}”
                    </blockquote>
                    <figcaption className="mt-3 flex items-center gap-2 text-xs text-background-300">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                        <i className="ri-user-fill" />
                      </span>
                      <span className="font-semibold text-background-50">{t.name}</span>
                      <span>· {t.role}</span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 联系方式表单 */}
        <section id="contact" className="mt-16 scroll-mt-20 md:mt-20">
          <div className="grid grid-cols-1 overflow-hidden rounded-3xl border border-background-200 bg-background-50 lg:grid-cols-2">
            <div className="flex flex-col justify-center p-7 md:p-10">
              <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
                <i className="ri-chat-3-line" /> 联系方式
              </p>
              <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">想反馈或交流，欢迎留言</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                对地址清单有建议、遇到打不开想确认状态，或想分享更好用的互换技巧，
                都可以通过表单告诉我，看到会尽快回复。
              </p>
              <ul className="mt-6 space-y-3 text-sm text-foreground-700">
                <li className="flex items-center gap-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className="ri-mail-line" />
                  </span>
                  hello@example.email
                </li>
                <li className="flex items-center gap-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className="ri-time-line" />
                  </span>
                  通常在 1 个工作日内回复
                </li>
              </ul>
            </div>

            <div className="bg-background-100/60 p-7 md:p-10">
              {sent ? (
                <div className="flex h-full flex-col items-center justify-center py-10 text-center">
                  <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-500 text-3xl text-background-50">
                    <i className="ri-check-line" />
                  </span>
                  <h3 className="mt-4 text-xl font-bold text-foreground-950">留言已收到</h3>
                  <p className="mt-2 max-w-xs text-sm text-foreground-700">
                    谢谢你的反馈，我会尽快查看并回复你。
                  </p>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                      <label htmlFor="contact-name" className="mb-1.5 block text-sm font-medium text-foreground-800">
                        怎么称呼
                      </label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        placeholder="你的昵称"
                        className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="mb-1.5 block text-sm font-medium text-foreground-800">
                        联系邮箱
                      </label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="you@example.com"
                        className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-msg" className="mb-1.5 block text-sm font-medium text-foreground-800">
                      留言内容
                    </label>
                    <textarea
                      id="contact-msg"
                      name="message"
                      value={msg}
                      onChange={(e) => setMsg(e.target.value)}
                      required
                      maxLength={500}
                      rows={5}
                      placeholder="想反馈的问题、建议或想交流的话题……"
                      className="w-full resize-none rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                    />
                  </div>
                  {/* 反垃圾隐藏字段 */}
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="absolute -left-[9999px] h-0 w-0 opacity-0"
                  />
                  {error && (
                    <p className="rounded-lg bg-primary-100 px-4 py-2 text-sm text-primary-800">{error}</p>
                  )}
                  <button
                    type="submit"
                    className="w-full whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
                  >
                    发送留言
                    <i className="ri-send-plane-line ml-2" />
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}